// we have to support IE11 and this will help us apply specific CSS in certain cases
if (/rv:11\.0\) like Gecko/g.test(navigator.userAgent)) {
  document.body.classList.add('isIE11');
}

// find out if user is using android device
export const isAndroid = /Android/g.test(navigator.userAgent); // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/useragent.js